module.exports = __webpack_public_path__ + "static/media/Estriol.717ccf85.png";